skrilla.controller('matchDetailsCtrl', function ($scope, searchService, $stateParams, modalService, cacheService, objectChangeService, srefService, sportService, adminService) {
  $scope.key = "matchDetails";

  $scope.getData = function () {
    searchService.get('matches/' + $stateParams.id).then(function (response) {
      $scope.match = response.data;
      $scope.newSource = $scope.match.sourceId;

      cacheService.registerObject($scope.key, $scope.match);
      objectChangeService.registerObject($scope.key, "match", $scope);
    });
  }

  $scope.publish = function () {
    searchService.post('matches/' + $stateParams.id + "/publish").then(function (response) {
      $scope.getData()
    });
  }

  $scope.gotoFantasy = function () {
    srefService.go($scope.match.sport.toLowerCase() + "MatchDetails", {id: $scope.match.id});
  }
  $scope.findMarkets = function () {
    srefService.go("bettingMarkets", {eventId: $scope.match.id});
  }
  $scope.createMarket = function () {
    srefService.go("createBettingMarket", {eventId: $scope.match.id, eventType: 'MATCH'});
  }
  $scope.updateStreams = function(){
    modalService.openModal("views/updateStreamUrisModal/updateStreamUrisModal.html", true, 'lg', true, true, function(){
      cacheService.registerObject($scope.key, $scope.match);
    });
  }

  $scope.voidSelections = function () {
    const bettingEvent = {
      eventId: $scope.match.id,
      eventName: $scope.match.name,
      scheduledStartTime: $scope.match.scheduledStartTime
    }
    cacheService.registerObject("bettingEvent", bettingEvent)
    modalService.openModal("views/bettingMarkets/voidEventMarketSelectionsModal.html", true, 'lg', true, true, function () {
      modalService.dismissAll();
    });
  }

  $scope.getData()

});

